import http, { IHttp } from 'lib/http';
import { IProfileResponse, IUpdateProfileData } from 'Modules/AAA/types';
import { IEntityInfo } from './types';

export const fetchEntityInfo = (fetcher = http): Promise<IEntityInfo> => fetcher.get('profile/entity');
export const saveEntityInfo = (data: IEntityInfo): Promise<IEntityInfo> => http.patch('profile/entity', data);
export const getInvoice = (amount: number): Promise<{}> =>
  http
    .get('profile/entity/invoice.pdf', { amount }, { responseType: 'arraybuffer' })
    .then((blob: any) => new Blob([blob as Blob], { type: 'application/pdf' }));

export const getContract = (): Promise<{}> =>
  http
    .get('profile/entity/contract.pdf', {}, { responseType: 'arraybuffer' })
    .then((blob: any) => new Blob([blob as Blob], { type: 'application/pdf' }));

export const uploadContracts = (files?: File[]): Promise<{}> => {
  if (files?.length) {
    const formData = new FormData();
    files.map(f => formData.append('documents[]', f, f.name));

    return http.post('profile/entity/upload', formData);
  }

  return http.post('profile/entity/upload');
};

export const fetchContractFileByLink = (url: string): Promise<File> => {
  const fileName = url.match(/[^\/]+$/)?.[0] || '';

  return http
    .get(
      url,
      {},
      {
        responseType: 'arraybuffer',
      }
    )
    .then((blob: any) => new File([blob as Blob], fileName));
};
interface IEntityHttp {
  createEntity(authData: IUpdateProfileData): Promise<IProfileResponse>;
  fetchEntityInfo?(fetcher?: IHttp): Promise<IEntityInfo>;
  getInvoice?(amount: number): Promise<unknown>;
  getContract?(): Promise<unknown>;
  uploadContracts?(files?: File[]): Promise<unknown>;
  fetchContractFileByUrl?(url: string): Promise<File>;
}
export class EntityHttp implements IEntityHttp {
  private readonly http: IHttp = http;

  public createEntity(entity: IUpdateProfileData): Promise<IProfileResponse> {
    return this.http.post('profile/entity', entity);
  }
}

export default new EntityHttp();
